import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Handle, Position } from 'reactflow';

import { AppTheme } from '../../../../styles/AppTheme';
import { HANDLE_OUT } from './automationGraph';
import { AutomationNodeMenu } from './AutomationNodeMenu';

const HANDLE_STYLE = {
  width: 10,
  height: 10,
  background: AppTheme.primaryColor,
  border: '2px solid #ffffff',
};

export function AutomationStepNode(props) {
  const data = props.data || {};
  const title = data.label || props.type || 'Step';
  return (
    <div className={css(Styles.card, props.selected && Styles.cardSelected)}>
      <Handle type='target' position={Position.Left} style={HANDLE_STYLE} />
      <div className={css(Styles.header)}>
        <span className={css(Styles.title)}>{title}</span>
        <AutomationNodeMenu onDelete={data.onDelete} onDuplicate={data.onDuplicate} />
      </div>
      <Handle type='source' position={Position.Right} id={HANDLE_OUT} style={HANDLE_STYLE} />
    </div>
  );
}

const Styles = StyleSheet.create({
  card: {
    width: 240,
    backgroundColor: AppTheme.secondaryBg,
    border: '1px solid ' + AppTheme.borderColor,
    borderRadius: AppTheme.borderRadius,
    overflow: 'visible',
    boxSizing: 'border-box',
  },
  cardSelected: {
    borderColor: AppTheme.primaryColor,
    boxShadow: '0 0 0 3px ' + AppTheme.primaryColor + '33',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 6px 8px 12px',
    borderBottom: '1px solid ' + AppTheme.borderColor,
    borderTopLeftRadius: AppTheme.borderRadius,
    borderTopRightRadius: AppTheme.borderRadius,
  },
  title: {
    fontSize: 13,
    fontWeight: 700,
    lineHeight: '18px',
    color: '#222222',
    minWidth: 0,
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});
